const validDocumentTypes = {
  'application/pdf': ['.pdf'], // .pdf
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'], // .docx
  'application/msword': ['.doc'], // .doc
  'image/jpeg': ['.jpg', '.jpeg'], // .jpg, .jpeg
  'image/bmp': ['.bmp'], // .bmp
  'image/gif': ['.gif'], // .gif
  'image/png': ['.png'], // .png
  'image/tiff': ['.tiff'] // .tiff
};

export default validDocumentTypes;